import api from './api';
const base='/helpdesk/admin/config';
const send=(path,method,data)=>api(`${base}${path}`,{method,body:JSON.stringify(data)});
export const HelpdeskConfigAPI={
  options:()=>api(`${base}/options`),
  createType:data=>send('/types','POST',data),
  updateType:(id,data)=>send(`/types/${id}`,'PUT',data),
  saveDepartment:(id,data)=>send(`/departments/${id}`,'PUT',data),
  saveSettings:data=>send('/settings','PUT',data),
  policies:()=>api(`${base}/sla/policies`),
  savePolicy:data=>send('/sla/policies','PUT',data),
  calendar:()=>api(`${base}/sla/calendar`),
  saveCalendar:data=>send('/sla/calendar','POST',data),
  importBankHolidays:data=>send('/sla/calendar/import-bank-holidays','POST',data),
};
